import {Component, OnInit} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {TeacherSessionApiService} from './teacher-session-api.service';

interface TeacherPlayer {
  authid: string;
  name: string;
  results: { period: number, values: Record<string, number> };
}

interface TeacherSession {
  gameId: string;
  sebgDebriefing: boolean;
  sessionId: number;
  currentPeriod: number;
  players: TeacherPlayer[];
}

@Component({
  selector: 'app-teacher-session',
  standalone: false,
  template: `
    <app-sebg-debriefing *ngIf="session?.sebgDebriefing"></app-sebg-debriefing>
    <p class="p-6" role="alert" *ngIf="error">{{error}} <button type="button" (click)="load()">Retry</button></p>
    <section class="p-6" *ngIf="session && !session.sebgDebriefing">
      <h1 class="text-xl font-semibold">Session comparison</h1>
      <p class="mb-4">Session {{session.sessionId}} · current period {{session.currentPeriod}} · read-only</p>
      <div class="overflow-x-auto">
        <table class="table">
          <thead><tr><th>Player</th><th>Auth ID</th><th>Latest period</th><th>Result values</th></tr></thead>
          <tbody>
            <tr *ngFor="let player of session.players">
              <td>{{player.name || 'Unnamed player'}}</td><td>{{player.authid}}</td><td>{{player.results.period}}</td>
              <td><div *ngFor="let value of player.results.values | keyvalue">{{value.key}}: {{value.value}}</div></td>
            </tr>
            <tr *ngIf="session.players.length === 0"><td colspan="4">No players are available for this session.</td></tr>
          </tbody>
        </table>
      </div>
    </section>
    <p class="p-6" *ngIf="!session && !error">Loading read-only session…</p>
  `
})
export class TeacherSessionComponent implements OnInit {
  session?: TeacherSession;
  error = '';
  constructor(private api: TeacherSessionApiService) {}
  ngOnInit(): void {
    this.load();
  }
  load(): void {
    this.error = '';
    this.api.summary<TeacherSession>().subscribe({
      next: value => this.session = value,
      error: (error: HttpErrorResponse) => this.error = error.status === 401
        ? 'Teacher authorization failed. Reopen the complete teacher link to restore your token.'
        : error.status === 403 ? 'This token does not permit teacher access.'
        : error.status === 0 ? 'The backend could not be reached. Check the browser network diagnostics.'
        : `Session data could not be loaded (HTTP ${error.status}). Please retry.`
    });
  }
}
